import { _ as _defineProperty } from '../_chunks/dep-adece2f7.js';
import { h } from 'vue';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var camel2Kebab = camelString => {
  var covertArr = ["clipRule", "fillRule", "maskType", "strokeLinecap", "strokeWidth"];
  if (covertArr.includes(camelString)) {
    return camelString.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, "$1-$2").toLowerCase();
  }
  return camelString;
};
var resolveChildProp = (value, props) => {
  var propName = value.split(".")[1];
  var overlapMask = /^overlapMask(Id|Url)_(.+)$/.exec(propName);
  if (overlapMask) {
    var maskId = "".concat(props.overlapMaskPrefix, "-overlap-").concat(overlapMask[2]);
    return overlapMask[1] === "Url" ? "url(#".concat(maskId, ")") : maskId;
  }
  return props[propName];
};
var renderNode = (node, props) => {
  var processedAttrs = {};
  if (node.attrs) {
    for (var [key, value] of Object.entries(node.attrs)) {
      if (typeof value === "string" && value.startsWith("props.")) {
        processedAttrs[camel2Kebab(key)] = resolveChildProp(value, props);
      } else {
        processedAttrs[camel2Kebab(key)] = value;
      }
    }
  }
  if (node.tag === "svg") {
    processedAttrs.class = props.class;
    processedAttrs.style = props.style;
    processedAttrs.onClick = props.onClick;
  }
  var children = node.children ? node.children.map(child => renderNode(child, props)) : [];
  return h(node.tag, processedAttrs, children);
};
var renderFn = (node, props) => {
  var overlapMaskPrefix = "t-icon-".concat(props.iconId, "-instance-").concat(props.overlapMaskInstanceId);
  return renderNode(node, _objectSpread(_objectSpread({}, props), {}, {
    overlapMaskPrefix
  }));
};

export default renderFn;
//# sourceMappingURL=render-fn.js.map
